module.exports = __webpack_public_path__ + "img/gy.2ecaea30.svg";